/** COPY OF `static/src_overrides/studios/universalstudios/titles/universal-cms/utils/navigationHelpers.js` */

/**
 * Check if Videos navigation item should be shown
 * Videos should appear when the videos page is active (toggled on)
 * @param {Object} movieData - Movie content data
 * @returns {boolean}
 */
export function shouldShowVideos(movieData) {
	return movieData?.pages?.videos?.active || false;
}

/**
 * Check if Tickets navigation item should be shown
 * Tickets should be shown only when ticketing date has been reached and page is active
 * @param {Object} movieData - Movie content data
 * @returns {boolean}
 */
export function shouldShowTickets(movieData) {
	// Check status.theaters which validates both page active AND date reached
	const status = movieData?.status;
	const showtimesAvailable = status?.theaters === 'preSale' || status?.theaters === 'inTheaters';
	return showtimesAvailable;
}

/**
 * Check if Watch at Home navigation item should be shown
 * Watch at Home should be shown only when HomeEnt date has been reached and page is active
 * @param {Object} movieData - Movie content data
 * @returns {boolean}
 */
export function shouldShowWatchAtHome(movieData) {
	// Check status.homeEnt which validates both page active AND date reached
	const status = movieData?.status;
	const shouldShow = status?.homeEnt === 'homeEnt';
	return shouldShow;
}

/**
 * Check if a navigation link should be displayed (works for both Focus Features and Universal Studios)
 * @param {Object} link - Navigation link object
 * @param {Object} movieData - Movie content data
 * @returns {boolean}
 */
export function shouldShowNavigationLink(link, movieData) {
	if (link.hidden || link.disabled) return false;

	switch (link.id) {
		case 'videos':
			return shouldShowVideos(movieData);
		case 'showtimes':
		case 'tickets':
			return shouldShowTickets(movieData);
		case 'watchathome':
		case 'homeEnt': // Universal Studios uses 'homeEnt' instead of 'watchathome'
			return shouldShowWatchAtHome(movieData);
		case 'synopsis':
		case 'gallery':
			return movieData?.pages?.[link.id]?.active ?? false;
		case 'home':
			return true; // Home is always shown
		default:
			return !!link.destination;
	}
}
